




































































import { Component, Vue } from 'vue-property-decorator';
import { Job } from '@/@types/LibraryComponent';
import JobCard from '@/components/jobList/table/JobCard.vue';
import ApplicationForm from './ApplicationForm.vue';

interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}
interface BookmarkJob {
  id: string;
  title: string;
  companyName: string;
  price: string;
  workPlaceAddress: string;
  skills: Array<string>;
  features: Array<string>;
  isBookmarked: boolean;
}

@Component({
  components: {
    JobCard,
    ApplicationForm,
  },
})
export default class Application extends Vue {
  private jobs: Array<
    Job
  > = require('@/repository/mock/dummyData/job/jobList.json').jobs;
  private pageOption: PageOption = {
    count: 20,
    max: 2,
    min: 1,
    current: 1,
  };
  private headers = [
    { text: '概要', value: 'title', width: '25%' },
    { text: '会社', value: 'companyName', width: '15%' },
    { text: '単価', value: 'price', width: '15%' },
    { text: '勤務地', value: 'workPlaceAddress', width: '15%' },
    { text: 'スキル', value: 'skills', width: '15%' },
    { text: '特徴', value: 'features', width: '15%' },
  ];
  private selected: Array<BookmarkJob> = [];
  private get bookmarkJobs(): Array<BookmarkJob> {
    return this.jobs
      .filter((j) => j.isBookmarked)
      .map((j) => {
        return {
          id: j.id,
          title: j.title,
          companyName: j.company.name,
          price: j.price + j.unit,
          workPlaceAddress: j.workPlace.address,
          skills: j.skills,
          features: j.features.slice(0, 3),
          isBookmarked: j.isBookmarked,
        };
      });
  }
}
